import { render } from "./menu-item.html?vue&type=template&id=67b95734&scoped=true&ts=true&external"
import script from "./menu-item.ts?vue&type=script&lang=ts&external"
export * from "./menu-item.ts?vue&type=script&lang=ts&external"

import "./menu-item.scss?vue&type=style&index=0&id=67b95734&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b95734"]])

export default __exports__